import { Delete, Edit, ExpandMore, Info, Public } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Chip, IconButton, TableCell, TableRow } from "@mui/material";
import { cloneDeep } from "lodash";
import { IMaterial, MaterialContext } from "../../interfaces";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";
import { MaterialInfo } from "../Shared/MaterialInfo";
import { HtmlTooltip } from "../HtmlTooltip";
import { MaterialInputDialog } from "../MaterialInputDialog";
import React from "react";

interface IMaterialTableRow {
    material: IMaterial,
    onUpdate: (material: IMaterial, splitMaterial?: IMaterial) => void,
    onCopy: () => void,
    readonly: boolean,
    onRemove: () => void,
    key: any
}

export const MaterialTableRow: React.FC<IMaterialTableRow> = ({
    material,
    onUpdate,
    onCopy,
    readonly,
    onRemove,
    key
}) => {

    const handleChangeReturnStatus = (value: string | null) => {

        let currentMaterial = cloneDeep(material);
        onUpdate(currentMaterial);
    }

    const getActionColumnStyle = (statusId: number) => {

        return (statusId === 1 && !readonly) ? { width: '180px' } : {};
    }

    return (
        <TableRow className="material-row" key={key}>
            <TableCell>
                <Accordion elevation={0}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}

                    >
                        <Box width="100%">
                            <p><strong>{material.l3}</strong></p>
                            <small>{material.l1?.value}</small>
                            <small>{material.l2?.value}</small>
                        </Box>
                        <Box display="flex" justifyContent="flex-end" alignItems="center" >
                            {material.statusId === 3 &&
                                <Chip
                                    icon={<Public />}
                                    label="Material Out"
                                    color="warning"
                                    size="small"
                                />
                            }
                            {material.statusId === 1 &&
                                <Chip
                                    icon={<Edit />}
                                    label="Draft"
                                    color="info"
                                    size="small"
                                />
                            }
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <MaterialInfo material={material} />
                    </AccordionDetails>
                </Accordion>
            </TableCell>
            <TableCell>
                <p>{material.classes} </p>
            </TableCell>
            <TableCell>
                <p>{material.spareType?.value}</p>

            </TableCell>
            <TableCell>
                <MaterialIdentifiers material={material} />
            </TableCell>
            <TableCell>
                <p>{material.state?.value}</p>
            </TableCell>
            <TableCell>
                <p>
                    {material.quantity}
                    <span>({material.unitOfQuantity?.value})</span>
                </p>
            </TableCell>


            <TableCell sx={getActionColumnStyle(material.statusId ?? 0)}>


                {!readonly && <>
                    {(material.statusId === 1 || material.statusId === 3) &&
                        <MaterialInputDialog
                            entity={{ id: "", type: "STORAGEREQUEST" }}
                            context={MaterialContext.MaterialRow}
                            onSubmitMaterial={(material, splitMaterial) => onUpdate(material, splitMaterial)}
                            onCopy={onCopy}
                            material={material}
                            focus={false}
                        />
                    }
                    <IconButton aria-label="remove material" onClick={onRemove}>
                        <Delete />
                    </IconButton>
                </>}
            </TableCell>
        </TableRow >
    );
}

